export default __webpack_public_path__ + "static/media/Harness of Unrest.1bc6df9e.jpg";